module.exports = __webpack_public_path__ + "static/img/7.598016e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/7.png
// module id = NEKr
// module chunks = 0